import { formatDate } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DayTimeOptions } from 'src/app/classes/day-time-options';
import { EntityWithAvailable } from 'src/app/classes/entity-with-available.class';
import { Entity } from 'src/app/classes/entity.class';
import { EntityUnavailable } from 'src/app/classes/entityunavailable.class';
import { Hiring } from 'src/app/classes/hiring';
import { Leave } from 'src/app/classes/leave';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Planning } from 'src/app/classes/planning.class';
import { PlanningAsfaltteam } from 'src/app/classes/planningasfaltteam.class';
import { PlanningCutter } from 'src/app/classes/planningcutter.class';
import { PlanningDumper } from 'src/app/classes/planningdumper.class';
import { PlanningFixed } from 'src/app/classes/planningfixed.class';
import { PlanningHirePeople } from 'src/app/classes/planninghirepeople.class';
import { PlanningSet } from 'src/app/classes/planningset.class';
import { Project, isSubProject } from 'src/app/classes/project.class';
import { RealisationHourtype } from 'src/app/classes/realisation';
import { Status } from 'src/app/classes/status.class';
import { UserPlanning } from 'src/app/classes/user-planning';
import { User } from 'src/app/classes/user.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Functionalities } from 'src/app/services/auth/functionalities';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { PlanningDetailDialogService } from 'src/app/services/dialog/planning-detail-dialog.service';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { EntityTypeCode } from 'src/app/services/entities/entity-type.class';
import { EntityUnavailableService } from 'src/app/services/entities/entity-unavailable.service';
import { HiringService } from 'src/app/services/hiring.service';
import { LeaveService } from 'src/app/services/leave.service';
import { FormattedAddress } from 'src/app/services/location.service';
import { AutocompleteService, AutocompleteType } from 'src/app/services/planning/autocomplete.service';
import { PlanningFixedService } from 'src/app/services/planning/planning-fixed.service';
import { PlanningHasService } from 'src/app/services/planning/planning-has.service';
import { PlanningService } from 'src/app/services/planning/planning.service';
import { StatusService } from 'src/app/services/planning/status.service';
import { UserPlanningService } from 'src/app/services/planning/user-planning.service';
import { ProjectService } from 'src/app/services/project.service';
import { UserService } from 'src/app/services/user/user.service';
import { Utils } from 'src/app/utils.class';
import { Roles } from 'src/environments/dvds/roles';
import { PlanningHistoryDialogComponent } from '../../../components/planning-history-dialog/planning-history-dialog.component';
import { PLANNING_HISTORY_LABELS } from '../../../components/planning-history-dialog/planning-history-labels';
import { DateFullMonthAdapter } from '../../../date-adapters/date-full-month-adapter';
import { Settings } from '../../../settings.class';
import { LocalStorage } from '../../../storage.class';
import { entityAvailableValidator } from '../../../validators/entity-available.validator';
import { localUserAvailableValidator } from '../../../validators/local-user-available.validator';
import { userIsNotDeleted } from '../../../validators/user-is-not-deleted.validator';
import { PlanningDetailEmployeesComponent } from '../../transport-planning/planning-detail-employees/planning-detail-employees.component';
import { PlanningDetailContainerComponent } from '../planning-detail-container/planning-detail-container.component';
import { CodaltModusService } from './../../../services/codalt-modus.service';
import { AsphaltListComponent } from './asphalt-list/asphalt-list.component';
import { CutterListComponent } from './cutter-list/cutter-list.component';
import { HirePeopleSelectorDialogComponent } from './hire-people-selector-dialog/hire-people-selector-dialog.component';
import { disabledWhenFinal, RequiredRule } from './planning-detail-dialog.required-rules';
import { PlanningDetailViewModel } from './planning-detail-view-model';
import { WipetruckListComponent } from './wipetruck-list/wipetruck-list.component';

@Component({
    selector: 'app-planning-detail',
    templateUrl: './planning-detail-dialog.component.html',
    styleUrls: ['./planning-detail-dialog.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: DateFullMonthAdapter,
        },
    ],
    standalone: false,
})
export class PlanningDetailDialogComponent extends CodaltComponent implements OnInit, OnDestroy {
    viewModel = new PlanningDetailViewModel();
    saving = false;
    loadingHistory = false;
    form: FormGroup;
    mainPlanning: PlanningAsfaltteam | PlanningCutter | PlanningHasEntity;
    statusList: Status[];
    setList: EntityWithAvailable[];
    craneList: EntityWithAvailable[];
    asphaltOtherList: EntityWithAvailable[];
    stickyWagonList: EntityWithAvailable[];
    rollerList: EntityWithAvailable[];
    dumperList: EntityWithAvailable[];
    asfaltTeamList: EntityWithAvailable[];
    preparationTeamList: EntityWithAvailable[];
    projectteamList: EntityWithAvailable[];
    cutterList: EntityWithAvailable[];
    wipetruckList: EntityWithAvailable[];
    truckList: EntityWithAvailable[];
    hirePeopleList: Entity[];
    startTimes: DayTimeOptions[];
    endTimes: DayTimeOptions[];
    dialogTitle = 'Planning Registreren';
    executors: User[];
    asphaltExecutors: User[];
    projectManagers: User[];
    drivers: User[];
    users: User[] = [];
    usersMap: Map<number, User>;
    maxUsedTrucks = 0;
    availableTrucks = 0;
    fixedDate: Date;
    private latestFixedUntilItem: PlanningFixed;
    private fixedDaysList: PlanningFixed[] = [];
    statusControl: FormControl;

    /**
     * Used as [matDatepickerFilter] on the date field. Users who are not allowed to touch the fixed
     * area at all may not even select a fixed date; users who may still add a definitieve planning
     * on a fixed date (Functionalities.PlanningOverviewManagement) can select any date.
     */
    dateFilter = (date: Date | null): boolean => {
        if (!date || AuthorisationService.hasFunctionality(Functionalities.PlanningOverviewManagement)) {
            return true;
        }
        if (!this.latestFixedUntilItem) {
            return true;
        }
        const isOriginalDate = Utils.formatDate(date) === Utils.formatDate(this.mainPlanning.begindate);
        const isFixedByUntil = date.getTime() <= new Date(this.latestFixedUntilItem.fixeduntil).getTime();
        const isFixedByDay = Utils.isSpecificFixedDay(date, this.fixedDaysList);
        return (!isFixedByUntil && !isFixedByDay) || isOriginalDate;
    };
    autocompleteContractors: string[];
    autocompletePouringOff: string[];
    setListString = '';
    dumperListString = '';
    craneListString = '';
    rollerListString = '';
    stickyWagonString = '';
    otherString = '';
    initialStatus: string;

    externalChanged = false;
    @Input() planning: Planning;
    entitiesMap: Map<number, Entity>;
    planningList: Planning[];

    projects: Project[];

    searchAfasProjects$ = new Subject<string>();

    origPlanning: Planning;

    protected unavailableList: EntityUnavailable[];
    @ViewChild(CutterListComponent) private cutterListComponent: CutterListComponent;
    @ViewChild(WipetruckListComponent) private wipetruckListComponent: WipetruckListComponent;
    @ViewChild(AsphaltListComponent) private asphaltListComponent: AsphaltListComponent;
    @ViewChild(PlanningDetailEmployeesComponent) private employeesComponent: PlanningDetailEmployeesComponent;
    private truckSubscription = new Subscription();
    private entitySubscription = new Subscription();
    private avCheckSubscriptions: Subscription;

    private isCopy = false;

    mayBackToConcept = false;

    mayChangeFinalStatus = AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement);

    @ViewChild('projectSelect') projectSelect: NgSelectComponent;

    @Input() dialogRef: MatDialogRef<PlanningDetailContainerComponent>;

    hiringList: Hiring[];

    leave: Leave;

    PlanningStatus = this.environment.status.Planning;

    constructor(
        public dialog: MatDialog,
        private planningService: PlanningService,
        private planningFixedService: PlanningFixedService,
        private statusService: StatusService,
        private confirmDialogService: ConfirmDialogService,
        private entitiesService: EntitiesService,
        private entityUnavailableService: EntityUnavailableService,
        private planningHasService: PlanningHasService,
        private autocompleteService: AutocompleteService,
        private userService: UserService,
        private projectService: ProjectService,
        private userPlanningService: UserPlanningService,
        private hiringService: HiringService,
        private leaveService: LeaveService,
        private planningDetailDialogService: PlanningDetailDialogService,
        public codaltModusService: CodaltModusService
    ) {
        super();
    }

    print() {
        Utils.openTab('/planning-detail/' + this.planning.id);
    }

    openHistory() {
        if (!this.planning?.id || this.loadingHistory || this.environment.platform === 'buitengewoonbv') {
            return;
        }

        this.loadingHistory = true;

        const entityTypeKey =
            this.mainPlanning?.entitytype_key ??
            this.entitiesMap?.get(this.mainPlanning?.entity_id)?.entitytypes[0]?.key;

        this.subscriptions.add(
            this.planningService.getPlanningHistory(this.planning.id).subscribe({
                next: items => {
                    this.loadingHistory = false;

                    this.dialog.open(PlanningHistoryDialogComponent, {
                        data: {
                            items,
                            entityType: this.environment.entitytypes[entityTypeKey],
                            fieldLabels: this.environment.platform === 'dvds' ? PLANNING_HISTORY_LABELS : undefined,
                        },
                        panelClass: 'planning-history-dialog',
                        width: '90vw',
                        maxWidth: '1400px',
                        height: '85vh',
                    });
                },
                error: error => {
                    this.loadingHistory = false;
                    console.error('Error fetching planning history:', error);
                },
            })
        );
    }

    copy() {
        if (
            this.form.dirty ||
            (this.asphaltListComponent && this.asphaltListComponent.checkDirty()) ||
            (this.cutterListComponent && this.cutterListComponent.checkDirty()) ||
            (this.wipetruckListComponent && this.wipetruckListComponent.checkDirty())
        ) {
            this.confirmDialogService.confirm({
                title: 'Sla eerst je wijzigingen op',
                text: 'Voordat je een kopie kunt maken moet je eerst de wijzigingen die je hebt gemaakt opslaan.',
                confirm: 'Oke',
                cancel: null,
            });
        } else {
            const copyPlanning = structuredClone(this.planning);
            delete copyPlanning.id;
            copyPlanning.planning_has_id = -1;
            const planningItems = Utils.planningAllEntities(copyPlanning, true);
            planningItems.forEach(plnItem => {
                if (this.mainPlanning.entity_id === plnItem.entity_id) {
                    plnItem.id = -1;
                } else {
                    delete plnItem.id;
                }
                delete plnItem.planning_id;
                delete plnItem.updated_at;
            });
            copyPlanning.asphalt_list.forEach(a => delete a.id);
            copyPlanning.user_planning.forEach(userPlanning => {
                delete userPlanning.id;
                delete userPlanning.planning_id;
                delete userPlanning.updated_at;
            });
            this.dialogRef.afterClosed().subscribe(() => {
                setTimeout(() => {
                    this.planningDetailDialogService.openPlanning(copyPlanning);
                });
            });

            this.dialogRef.close();
        }
    }

    openEmployeesPlanning() {
        this.dialog.open(PlanningDetailEmployeesComponent, {
            width: '99vw',
            maxWidth: '1300px',
            minHeight: '500px',
            maxHeight: '95vh',
            disableClose: true,
            data: {
                planning: this.planning,
            },
        });
    }

    hirePeopleSelector() {
        if (this.viewModel.formDisabled) {
            return;
        }
        const ref = this.dialog.open(HirePeopleSelectorDialogComponent, {
            maxWidth: '500px',
            width: '300px',
            maxHeight: '100%',
            disableClose: true,
            panelClass: 'planning-detail-dialog',
            data: {
                planning: this.planning,
                entities: this.hirePeopleList,
                disabled: this.viewModel.formDisabled,
            },
        });
        ref.afterClosed().subscribe(hirePeoplePlannings => {
            if (!this.viewModel.formDisabled) {
                if (typeof hirePeoplePlannings === 'object') {
                    this.planning.planning_hire_people = [];
                    hirePeoplePlannings?.forEach(hire => {
                        const planningHire = new PlanningHirePeople();
                        planningHire.entitytype_key = EntityTypeCode.HirePeople;
                        Object.assign(planningHire, hire);
                        this.overrideDates(planningHire);
                        this.planning.planning_hire_people.push(planningHire);
                    });
                }
            }
        });
    }

    afasProjectClose() {
        if (this.projects.find(p => p.afas_project_id === this.form.get('worknumber').value)) {
            this.form.get('afas_project_id').setValue(this.form.get('worknumber').value);
            this.planning.afas_project_id = this.form.get('worknumber').value;
        }
    }

    afasProjectChange(projectId: string) {
        const project = this.projects.find(p => p.afas_project_id === projectId);
        if (!this.form.get('projectmanager').value) {
            this.form.get('projectmanager').setValue(project.projectmanager_id);
        }

        if (project.location_place && !this.form.get('location').value) {
            this.form
                .get('location')
                .setValue(
                    `${project.location_straat} ${project.location_housenumber}, ${project.location_postcode} ${project.location_place}`
                );
            this.form.get('asphalt_location')?.setValue(`${project.location_straat}, ${project.location_place}`);
        }
        this.form.get('afas_project_id').setValue(project.afas_project_id);
        this.planning.afas_project_id = project.afas_project_id;
    }

    ngOnInit() {
        if (!this.planning.id && this.planning.planning_has_id) {
            this.isCopy = true;
        }

        this.origPlanning = structuredClone(this.planning);

        this.mainPlanning = this.planningService.getMainPlanning(this.planning);

        this.subscriptions.add(
            this.searchAfasProjects$.pipe(debounceTime(200)).subscribe(search => {
                this.subscriptions.add(
                    this.projectService.searchProjects(search).subscribe(projects => {
                        this.projects = projects?.filter(isSubProject);
                    })
                );
            })
        );

        if (this.planning?.leave_id) {
            this.subscriptions.add(
                this.leaveService.getLeave(this.planning.leave_id).subscribe(leave => {
                    this.leave = leave.data;
                    if (!this.leave) {
                        this.leave = this.createLeave();
                    }
                })
            );
        } else if (this.planning.status_key == this.PlanningStatus.PlanningSlaapdag) {
            this.leave = this.createLeave();
        }

        if (this.planning.id) {
            this.subscriptions.add(
                this.planningService.getSingle(this.planning.id).subscribe(changed => {
                    if (!this.saving) {
                        if (!changed || this.planning.updated_at !== changed.updated_at) {
                            this.externalChanged = true;
                            this.viewModel.asphaltFormDisabled = true;
                            this.viewModel.formDisabled = true;
                            this.viewModel.entitiesDisabled = true;
                            this.viewModel.employeeDisabled = true;
                            this.form.get('date').disable({ emitEvent: false });
                            this.form.disable({ emitEvent: false });
                        }
                        if (changed) {
                            this.planning.user_planning = changed.user_planning;
                        }
                    }
                })
            );
        }

        this.initialStatus = this.planning.status_key;

        const user = LocalStorage.getUser();

        if (user.roles.find(g => g.key === this.environment.roles.Projectmanager) && !this.planning.projectmanager) {
            this.planning.projectmanager = user.id;
        }
        this.subscriptions.add(
            this.statusService.getList('planning').subscribe(statusList => {
                this.statusList = statusList.filter(
                    status =>
                        status.key !== this.PlanningStatus.PlanningBevestigd ||
                        AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement)
                );
            })
        );
        if (AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement)) {
            this.userService.getByType(this.environment.roles.TruckDriver).subscribe(drivers => {
                this.drivers = drivers;
            });
        }
        this.subscriptions.add(
            this.userService.getByType(this.environment.roles.Executor).subscribe(users => (this.executors = users))
        );
        this.subscriptions.add(
            this.userService
                .getByType(this.environment.roles.Asphaltexecutor)
                .subscribe(users => (this.asphaltExecutors = users))
        );
        this.subscriptions.add(
            this.userService
                .getByType(this.environment.roles.Projectmanager)
                .subscribe(users => (this.projectManagers = users))
        );
        this.subscriptions.add(this.userService.getList().subscribe(users => (this.users = users)));
        this.subscriptions.add(
            this.userService.getMap().subscribe(users => {
                this.usersMap = users;
                if (this.form) {
                    this.form.get('projectmanager').updateValueAndValidity();
                    this.form.get('performer').updateValueAndValidity();
                }
            })
        );

        if (this.mainPlanning.begindate) {
            this.mainPlanning.begindate = this.mainPlanning.begindate ? new Date(this.mainPlanning.begindate) : null;
            this.mainPlanning.enddate = this.mainPlanning.enddate ? new Date(this.mainPlanning.enddate) : null;
            this.genEndTimesList();
        }
        let entitiesMapInit = false;
        this.dialogTitle = 'Planning registreren';

        const initForm = () => {
            this.viewModel.updateViewState(this.mainPlanning.entitytype_key, user, this.planning);
            this.subscriptions.add(
                combineLatest([
                    this.planningFixedService.getLatestFixedUntilItem(),
                    this.planningFixedService.getFixedDays(),
                ]).subscribe(([fixed, fixedDays]) => {
                    this.latestFixedUntilItem = fixed;
                    this.fixedDaysList = fixedDays || [];
                    this.updateFixedState();
                })
            );
            if (this.viewModel.cutter) {
                this.subscriptions.add(
                    this.hiringService.getByType(EntityTypeCode.Cutter).subscribe(hiring => {
                        this.hiringList = hiring;
                    })
                );
            }
            this.createMainForm(this.planning, this.mainPlanning);
            this.subscriptions.add(
                this.entitiesService
                    .getList(
                        this.mainPlanning.begindate,
                        this.mainPlanning.enddate,
                        Utils.planningAllEntities(this.planning).map(pae => pae.entity_id)
                    )
                    .subscribe(entities => {
                        this.setList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Set)
                        ) as EntityWithAvailable[];
                        this.dumperList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Dumper)
                        ) as EntityWithAvailable[];
                        this.asfaltTeamList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.AsfaltTeam)
                        ) as EntityWithAvailable[];
                        this.preparationTeamList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.PreparationTeam)
                        ) as EntityWithAvailable[];
                        this.projectteamList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.ProjectTeam)
                        ) as EntityWithAvailable[];
                        this.cutterList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Cutter)
                        ) as EntityWithAvailable[];
                        this.wipetruckList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Wipetruck)
                        ) as EntityWithAvailable[];
                        this.truckList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Truck)
                        ) as EntityWithAvailable[];
                        this.hirePeopleList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.HirePeople)
                        );

                        this.rollerList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Roller)
                        ) as EntityWithAvailable[];
                        this.craneList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.Crane)
                        ) as EntityWithAvailable[];
                        this.stickyWagonList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.StickyWagon)
                        ) as EntityWithAvailable[];
                        this.asphaltOtherList = entities.filter(
                            entity => !!entity.entitytypes.find(et => et.key === EntityTypeCode.AsphaltOther)
                        ) as EntityWithAvailable[];

                        if (!this.planning.id && !this.isCopy) {
                            this.form
                                .get('rollers')
                                ?.setValue([
                                    ...this.rollerList
                                        .filter(c => c.team_entity_id === this.mainPlanning.entity_id)
                                        .map(c => c.id),
                                ]);
                            this.form
                                .get('dumpers')
                                ?.setValue([
                                    ...this.dumperList
                                        .filter(c => c.team_entity_id === this.mainPlanning.entity_id)
                                        .map(c => c.id),
                                ]);
                            this.form
                                .get('asphalt_others')
                                ?.setValue([
                                    ...this.asphaltOtherList
                                        .filter(c => c.team_entity_id === this.mainPlanning.entity_id)
                                        .map(c => c.id),
                                ]);
                        }

                        this.updateEntityAvailability();
                    })
            );
            this.trucks();
            this.updateStatus();
        };

        this.subscriptions.add(
            this.entitiesService.getMap().subscribe(entitiesMap => {
                this.entitiesMap = entitiesMap;
                this.dialogTitle =
                    (this.entitiesMap?.get(this.mainPlanning.entity_id)?.entitytypes[0]?.name ?? 'Planning') +
                    ' registreren';
                if (!entitiesMapInit) {
                    initForm();
                }
                entitiesMapInit = true;
            })
        );
    }

    setTimesSubscription() {
        if (this.avCheckSubscriptions) {
            this.avCheckSubscriptions.unsubscribe();
        }
        if (this.mainPlanning.begindate) {
            const fromDate = new Date(this.mainPlanning.begindate);
            fromDate.setHours(0);
            const toDate = new Date(fromDate);
            toDate.setUTCHours(toDate.getUTCHours() + 24);
            const entitiesMap$ = this.entitiesService.getMap();
            const fromDateUnavailable = new Date(fromDate);
            fromDateUnavailable.setDate(fromDateUnavailable.getDate() - 14);
            const planning$ = this.planningService.getFilteredList(fromDateUnavailable, toDate);
            const unavailable$ = this.entityUnavailableService.getFilteredList(fromDateUnavailable, toDate);
            this.avCheckSubscriptions = new Subscription();
            this.avCheckSubscriptions.add(
                combineLatest(entitiesMap$, unavailable$, planning$).subscribe(
                    ([entitiesMap, unavailableList, planningList]) => {
                        if (!this.saving) {
                            this.unavailableList = unavailableList;
                            this.planningList = planningList;
                            this.entitiesMap = entitiesMap;
                            this.startTimes = Utils.genTimesMapOneEntity(
                                fromDate,
                                toDate,
                                this.mainPlanning as PlanningHasEntity,
                                this.mainPlanning.planning_id,
                                this.planningList,
                                this.unavailableList
                            );
                            if (this.mainPlanning.begindate) {
                                this.genEndTimesList();
                            }
                        }
                    }
                )
            );
        }
    }

    delete() {
        this.confirmDialogService
            .confirm({
                title: 'Planning verwijderen',
                text: 'Weet u zeker dat u deze planning wilt verwijderen?',
                confirm: 'Verwijderen',
                cancel: 'Annuleren',
            })
            .then(
                () => {
                    this.planningService.deletePlanning(this.planning.id).then(() => {
                        this.dialogRef.close();
                    });
                },
                () => {}
            );
    }

    trucks() {
        if (!this.planning) {
            return;
        }

        if (this.truckSubscription) {
            this.truckSubscription.unsubscribe();
        }
        if (this.entitySubscription) {
            this.entitySubscription.unsubscribe();
        }

        if (this.mainPlanning.begindate) {
            this.truckSubscription = this.planningService
                .getMaxUsedTrucksForRange(
                    this.mainPlanning.begindate,
                    this.mainPlanning.enddate,
                    this.mainPlanning.planning_id
                )
                .subscribe(maxUsedTrucks => {
                    this.maxUsedTrucks = maxUsedTrucks;
                });
            this.entitySubscription = this.entityUnavailableService
                .getTrucksAvailableForRange(this.mainPlanning.begindate, this.mainPlanning.enddate)
                .subscribe(availableTrucks => {
                    this.availableTrucks = availableTrucks;
                });
        } else {
            this.availableTrucks = this.maxUsedTrucks = 0;
        }
    }

    save() {
        if (this.planning.status_key === this.PlanningStatus.PlanningGeblokkeerd) {
            this.planning.planning_has = this.planning.planning_has?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_sets = this.planning.planning_sets?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_trucks = this.planning.planning_trucks?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_dumpers = this.planning.planning_dumpers?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_cranes = this.planning.planning_cranes?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_has = this.planning.planning_has?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_sticky_wagons = this.planning.planning_sticky_wagons?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_asphalt_others = this.planning.planning_asphalt_others?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_rollers = this.planning.planning_rollers?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_cutters = this.planning.planning_cutters?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
            this.planning.planning_wipetrucks = this.planning.planning_wipetrucks?.filter(
                ph => ph.entitytype_key === this.mainPlanning.entitytype_key
            );
        }

        this.planning.planning_hire_people?.forEach(hire => {
            hire.begindate = new Date(this.mainPlanning.begindate);
            hire.enddate = new Date(this.mainPlanning.enddate);
        });
        this.saving = true;

        const allPromises = [
            this.cutterListComponent?.validateForms() ?? of(true),
            this.wipetruckListComponent?.validateForms() ?? of(true),
            this.asphaltListComponent?.validateForms() ?? of(true),
            this.employeesComponent?.validateForms() ?? of(true),
            Utils.triggerValidationP(this.form, [], true),
        ];

        Promise.all(allPromises).then(
            () => {
                if (this.cutterListComponent && !this.cutterListComponent.formsDisabled) {
                    console.log('Apply planning_cutters');
                    this.planning.planning_cutters = this.cutterListComponent.planningEntitiesList;
                }
                if (this.wipetruckListComponent && !this.wipetruckListComponent.formsDisabled) {
                    console.log('Apply planning_wipetrucks');
                    this.planning.planning_wipetrucks = this.wipetruckListComponent.planningEntitiesList;
                }
                if (this.asphaltListComponent && !this.asphaltListComponent.formsDisabled) {
                    console.log('Apply asphalt_list');
                    this.planning.asphalt_list = this.asphaltListComponent.planningAsphaltList;
                }
                if (this.employeesComponent && !this.employeesComponent.formsDisabled) {
                    console.log('Apply user_planning');
                    this.planning.user_planning = this.withResolvedUserPlanningPerformers(
                        this.employeesComponent.form.value as unknown as UserPlanning[]
                    );
                }
                this.saveAction();
            },
            results => {
                for (const name of Object.keys(this.form.controls)) {
                    if (!this.form.controls[name].valid) {
                        console.log('INVALID', name, this.form.controls[name]);
                    }
                    this.form.controls[name].markAsTouched();
                    if (this.form.controls[name] instanceof FormGroup) {
                        const formGroup = this.form.controls[name] as FormGroup;
                        for (const subname of Object.keys(formGroup.controls)) {
                            formGroup.controls[subname].markAsTouched();
                        }
                    }
                }
                this.saving = false;
                console.log('Validation errors', results, this.form);
            }
        );
    }

    close() {
        if (
            (this.form.dirty ||
                (this.asphaltListComponent && this.asphaltListComponent.checkDirty()) ||
                (this.cutterListComponent && this.cutterListComponent.checkDirty()) ||
                (this.wipetruckListComponent && this.wipetruckListComponent.checkDirty())) &&
            (!this.viewModel.formDisabled || !this.viewModel.asphaltFormDisabled)
        ) {
            if (this.externalChanged) {
                this.confirmDialogService
                    .confirm({
                        title: 'Wijzigingen gaan verloren',
                        text:
                            'Je hebt wijzigingen aangebracht, maar in de tussentijd heeft iemand anders deze planning ook aangepast. ' +
                            'Helaas kunnen we jouw wijzigingen niet opslaan.',
                        confirm: 'Oke',
                        cancel: null,
                    })
                    .then(
                        () => {
                            this.dialogRef.close();
                        },
                        () => {
                            this.dialogRef.close();
                        }
                    );
            } else {
                this.confirmDialogService
                    .confirm({
                        title: 'Wijzigingen opslaan',
                        text: 'Je hebt wijzigingen aangebracht. Wil je deze opslaan?',
                        confirm: 'Opslaan',
                        cancel: 'Niet opslaan',
                    })
                    .then(
                        () => {
                            this.save();
                        },
                        () => {
                            this.dialogRef.close();
                        }
                    );
            }
        } else {
            this.dialogRef.close();
        }
    }

    ngOnDestroy() {
        this.truckSubscription?.unsubscribe();
        this.entitySubscription?.unsubscribe();
        this.avCheckSubscriptions?.unsubscribe();
        this.subscriptions.unsubscribe();
    }

    overrideDates(item: PlanningCutter | PlanningAsfaltteam | PlanningHasEntity | PlanningSet | PlanningHirePeople) {
        if (!disabledWhenFinal(this)) {
            item.begindate = this.mainPlanning.begindate;
            item.enddate = this.mainPlanning.enddate;
        }
    }

    formChanges() {
        const formValues = this.form.getRawValue();
        for (const [key, value] of Object.entries(formValues)) {
            if (
                [
                    'set',
                    'sets',
                    'dumpers',
                    'rollers',
                    'asfaltteam',
                    'preparationteam',
                    'projectteam',
                    'cutter',
                    'wipetruck',
                    'date',
                    'asphalt_others',
                ].indexOf(key) !== -1
            ) {
                if (key === 'date') {
                    if (this.form.get('date').touched) {
                        if (this.viewModel.asfaltteam) {
                            this.form.get('asfaltteam').markAsTouched();
                        }
                        if (this.viewModel.projectteam) {
                            this.form.get('projectteam').markAsTouched();
                        }
                        if (this.viewModel.preparationteam) {
                            this.form.get('preparationteam').markAsTouched();
                        }
                        if (this.viewModel.set) {
                            this.form.get('sets').markAsTouched();
                        }
                        if (this.viewModel.dumpers) {
                            this.form.get('dumpers').markAsTouched();
                        }
                        if (this.viewModel.cutter) {
                            this.form.get('cutter').markAsTouched();
                        }
                        if (this.viewModel.rollers) {
                            this.form.get('rollers').markAsTouched();
                        }
                        this.updateEntityAvailability();
                        this.form.get('date').markAsUntouched();
                    }
                } else if (key === 'asfaltteam' && this.mainPlanning.entitytype_key === EntityTypeCode.AsfaltTeam) {
                    this.mainPlanning.entity_id = value as number;
                    this.mainPlanning.entity = this.entitiesMap.get(this.mainPlanning.entity_id);
                    this.planning.planning_asfaltteam.entity_id = value as number;
                    this.overrideDates(this.planning.planning_asfaltteam);
                    this.viewModel.updateViewState(
                        this.mainPlanning.entitytype_key,
                        LocalStorage.getUser(),
                        this.planning,
                        !!this.fixedDate
                    );
                } else if (key === 'projectteam' && this.mainPlanning.entitytype_key === EntityTypeCode.ProjectTeam) {
                    this.mainPlanning.entity = this.entitiesMap.get(value as number);
                    if (!this.form.get('performer').value && this.mainPlanning?.entity?.default_performer_id) {
                        this.form.get('performer').setValue(this.mainPlanning.entity.default_performer_id);
                    }
                    if (value !== this.mainPlanning.entity_id) {
                        this.genEndTimesList();
                    }
                    this.mainPlanning.entity_id = value as number;
                    this.mainPlanning.entity = this.entitiesMap.get(this.mainPlanning.entity_id);
                    this.planning.planning_projectteam.entity_id = value as number;
                    this.overrideDates(this.planning.planning_projectteam);
                    this.viewModel.updateViewState(
                        this.mainPlanning.entitytype_key,
                        LocalStorage.getUser(),
                        this.planning,
                        !!this.fixedDate
                    );
                } else if (
                    key === 'preparationteam' &&
                    this.mainPlanning.entitytype_key === EntityTypeCode.PreparationTeam
                ) {
                    this.mainPlanning.entity_id = value as number;
                    this.mainPlanning.entity = this.entitiesMap.get(this.mainPlanning.entity_id);
                    this.planning.planning_preparationteam.entity_id = value as number;
                    this.overrideDates(this.planning.planning_preparationteam);
                    this.viewModel.updateViewState(
                        this.mainPlanning.entitytype_key,
                        LocalStorage.getUser(),
                        this.planning,
                        !!this.fixedDate
                    );
                } else if (key === 'sets' && this.mainPlanning.entitytype_key === EntityTypeCode.AsfaltTeam) {
                    if (disabledWhenFinal(this)) {
                        delete this.planning.planning_sets;
                    } else {
                        this.planning.planning_sets = [];
                        (value as number[]).forEach(set => {
                            const planningSet = new PlanningSet();
                            planningSet.entity_id = set;
                            planningSet.entitytype_key = EntityTypeCode.Set;
                            planningSet.planning_id = this.planning.id;
                            this.overrideDates(planningSet);
                            this.planning.planning_sets.push(planningSet);
                        });
                    }
                } else if (key === 'dumpers' && this.mainPlanning.entitytype_key === EntityTypeCode.AsfaltTeam) {
                    if (disabledWhenFinal(this)) {
                        delete this.planning.planning_dumpers;
                    } else {
                        this.planning.planning_dumpers = [];
                        (value as number[]).forEach(dumper => {
                            const planningDumper = new PlanningDumper();
                            planningDumper.entity_id = dumper;
                            planningDumper.entitytype_key = EntityTypeCode.Dumper;
                            planningDumper.planning_id = this.planning.id;
                            this.overrideDates(planningDumper);
                            this.planning.planning_dumpers.push(planningDumper);
                        });
                    }
                } else if (key === 'rollers' && this.mainPlanning.entitytype_key === EntityTypeCode.AsfaltTeam) {
                    if (disabledWhenFinal(this)) {
                        delete this.planning.planning_rollers;
                    } else {
                        this.planning.planning_rollers = [];
                        (value as number[]).forEach(dumper => {
                            const planningRoller = new PlanningHasEntity();
                            planningRoller.entity_id = dumper;
                            planningRoller.entitytype_key = EntityTypeCode.Roller;
                            planningRoller.planning_id = this.planning.id;
                            this.overrideDates(planningRoller);
                            this.planning.planning_rollers.push(planningRoller);
                        });
                    }
                } else if (key === 'asphalt_others' && this.mainPlanning.entitytype_key === EntityTypeCode.AsfaltTeam) {
                    if (disabledWhenFinal(this)) {
                        delete this.planning.planning_asphalt_others;
                    } else {
                        this.planning.planning_asphalt_others = [];
                        (value as number[]).forEach(asphaltOther => {
                            const planningAsphaltOther = new PlanningHasEntity();
                            planningAsphaltOther.entity_id = asphaltOther;
                            planningAsphaltOther.entitytype_key = EntityTypeCode.AsphaltOther;
                            planningAsphaltOther.planning_id = this.planning.id;
                            this.overrideDates(planningAsphaltOther);
                            this.planning.planning_asphalt_others.push(planningAsphaltOther);
                        });
                    }
                } else if (key === 'cutter' && this.mainPlanning.entitytype_key === EntityTypeCode.Cutter) {
                    const mainPlanning = this.mainPlanning as PlanningCutter;
                    mainPlanning.entity_id = value['cutter'];
                    mainPlanning.driver_user_id = value['driver_user_id'];
                    mainPlanning.tons = value['tons'];
                    mainPlanning.thickness = value['thickness'];
                    mainPlanning.trucks = value['trucks'];
                    mainPlanning.location = value['location'];
                    if (!this.entitiesMap.get(value['cutter'])?.use_once) {
                        mainPlanning.hiring_id = value['hiring_id'];
                        mainPlanning.name = value['name'];
                    }
                    this.planning.planning_cutters[0].entity_id = value['cutter'];
                    this.planning.planning_cutters[0].driver_user_id = mainPlanning.driver_user_id;
                    this.overrideDates(this.planning.planning_cutters[0]);
                } else if (key === 'wipetruck' && this.mainPlanning.entitytype_key === EntityTypeCode.Wipetruck) {
                    const mainPlanning = this.mainPlanning as PlanningCutter;
                    mainPlanning.entity_id = value['wipetruck'];
                    mainPlanning.driver_user_id = value['driver_user_id'];
                    mainPlanning.type = value['type'];
                    this.overrideDates(this.planning.planning_wipetrucks[0]);
                }
            } else {
                this.planning[key] = value;
            }
        }
        this.trucks();

        const makeString = (ewa: EntityWithAvailable[], selectedEntities: { entity_id: number }[]): string => {
            if (ewa && selectedEntities) {
                return ewa
                    .filter(p => !!selectedEntities.find(ps => ps.entity_id === p.id))
                    .map(p => p.name)
                    .join('\r\n');
            }
            return '';
        };

        this.setListString = makeString(this.setList, this.planning?.planning_sets);
        this.dumperListString = makeString(this.dumperList, this.planning?.planning_dumpers);
        this.rollerListString = makeString(this.rollerList, this.planning?.planning_rollers);
        this.otherString = makeString(this.asphaltOtherList, this.planning?.planning_asphalt_others);
    }

    private saveAction() {
        const savePlanning = () => {
            this.planningService.saveOld(this.planning).then(
                planning => {
                    this.saving = false;
                    this.planning.id = planning.id;

                    this.dialogRef.close(this.planning);
                },
                error => {
                    Utils.handleError(error, this.confirmDialogService);
                    this.saving = false;
                }
            );
        };
        if (this.leave) {
            this.subscriptions.add(
                this.leaveService.saveLeave({ ...this.leave, users: this.leave.users?.map(u => u.id) }).subscribe({
                    next: savedLeave => {
                        this.planning.leave_id = savedLeave.data.id;
                        savePlanning();
                    },
                    error: error => {
                        Utils.handleError(error, this.confirmDialogService);
                        this.saving = false;
                    },
                })
            );
        } else {
            savePlanning();
        }
    }

    /**
     * Resolves the performer in this order:
     * 1. User not found: regular performer from the asphalt planning.
     * 2. hours_checked_by set: the assigned hour checker.
     * 3. hours_checked_by_role set: no performer.
     * 4. Employee can approve hours: the employee themselves.
     * 5. Asphalt employee or compact machinist: asphalt performer.
     * 6. All other employees: regular performer.
     */
    private withResolvedUserPlanningPerformers(userPlanningList: UserPlanning[]): UserPlanning[] {
        return userPlanningList.map(userPlanning => {
            const user = this.users.find(existingUser => existingUser.id === userPlanning.user_id);
            if (!user) {
                return { ...userPlanning, performer_id: this.planning.performer };
            }

            if (user.hours_checked_by) {
                return { ...userPlanning, performer_id: user.hours_checked_by };
            }

            if (user.hours_checked_by_role) {
                return { ...userPlanning, performer_id: null };
            }

            if (AuthorisationService.canApproveHours(user)) {
                return { ...userPlanning, performer_id: user.id };
            }

            return {
                ...userPlanning,
                performer_id: AuthorisationService.hasAnyRole([Roles.Asphalt, Roles.CompactMachinist], user)
                    ? this.planning.asphalt_performer
                    : this.planning.performer,
            };
        });
    }

    private genEndTimesList() {
        if (this.entitiesMap) {
            const fromDate = new Date(this.mainPlanning.begindate);
            fromDate.setUTCHours(fromDate.getUTCHours() + 1);
            const toDate = new Date(fromDate);
            const maxTime =
                this.statusControl.value === this.PlanningStatus.PlanningGeblokkeerd
                    ? Settings.DEFAULT_DURATION_BLOCK
                    : Settings.MAX_TIMESPAN_HOURS;
            toDate.setUTCHours(toDate.getUTCHours() + maxTime);
            if (this.mainPlanning.entity && this.planningList) {
                this.endTimes = Utils.genTimesMapOneEntity(
                    fromDate,
                    toDate,
                    this.mainPlanning as PlanningHasEntity,
                    this.mainPlanning.planning_id,
                    this.planningList,
                    this.unavailableList,
                    true
                );
            }
        }
    }

    private updateEntityAvailability() {
        if (this.mainPlanning.begindate) {
            this.entitiesService
                .getUnavailableEntityIds(
                    this.mainPlanning.planning_id,
                    this.mainPlanning.begindate,
                    this.mainPlanning.enddate
                )
                .then(unavailableIds => {
                    const allEntities = [
                        ...this.cutterList,
                        ...this.wipetruckList,
                        ...this.setList,
                        ...this.asfaltTeamList,
                        ...this.dumperList,
                        ...this.truckList,
                        ...this.rollerList,
                        ...this.craneList,
                        ...this.asphaltOtherList,
                        ...this.stickyWagonList,
                    ];
                    const onlyForMain = [this.mainPlanning.entitytype_key];

                    if (this.mainPlanning.entitytype_key === EntityTypeCode.AsfaltTeam) {
                        onlyForMain.push(EntityTypeCode.Set);
                        onlyForMain.push(EntityTypeCode.Dumper);
                    }
                    allEntities
                        .filter(e => onlyForMain.indexOf(e.entitytype_key) !== -1)
                        .forEach(entity => {
                            entity.notAvailable = unavailableIds.indexOf(entity.id) !== -1;
                            if (entity.entitytype_key === EntityTypeCode.Set) {
                                if (this.planning.planning_sets) {
                                    entity.usedHere =
                                        this.planning.planning_sets.map(e => e.entity_id).indexOf(entity.id) !== -1;
                                } else {
                                    entity.usedHere = false;
                                }
                            }
                            if (entity.entitytype_key === EntityTypeCode.Dumper) {
                                if (this.planning.planning_dumpers) {
                                    entity.usedHere =
                                        this.planning.planning_dumpers.map(e => e.entity_id).indexOf(entity.id) !== -1;
                                } else {
                                    entity.usedHere = false;
                                }
                            }
                            if (entity.entitytype_key === EntityTypeCode.Roller) {
                                if (this.planning.planning_rollers) {
                                    entity.usedHere =
                                        this.planning.planning_rollers.map(e => e.entity_id).indexOf(entity.id) !== -1;
                                } else {
                                    entity.usedHere = false;
                                }
                            }
                        });
                    if (typeof this.cutterListComponent !== 'undefined') {
                        this.cutterListComponent.checkAddPossibility();
                    }
                    if (typeof this.wipetruckListComponent !== 'undefined') {
                        this.wipetruckListComponent.checkAddPossibility();
                    }
                });
        }
    }

    focusProjectSelect() {
        this.projectSelect?.filter(this.planning.worknumber);
    }

    addressSelected(address: FormattedAddress | null) {
        if (address?.formattedAddress) {
            this.form.get('asphalt_location').setValue(address.formattedAddress);
        }
    }

    private createMainForm(
        planning: Planning,
        mainPlanning: PlanningAsfaltteam | PlanningCutter | PlanningHasEntity,
        resetTransport = false
    ) {
        this.form = new FormGroup({
            status_key: (this.statusControl = new FormControl(
                planning.status_key || this.PlanningStatus.PlanningReservering,
                [Validators.required]
            )),
            date: new FormGroup({
                date: new FormControl(
                    { value: mainPlanning.begindate, disabled: disabledWhenFinal(this) },
                    RequiredRule(this)
                ),
                begintime: new FormControl(Utils.getTimeOrNull(mainPlanning.begindate), RequiredRule(this)),
                endtime: new FormControl(Utils.getTimeOrNull(mainPlanning.enddate), RequiredRule(this)),
            }),
            projectmanager: new FormControl(planning.projectmanager, [RequiredRule(this), userIsNotDeleted(this)]),
            performer: new FormControl(planning.performer ?? this.mainPlanning?.entity?.default_performer_id, [
                RequiredRule(this),
                userIsNotDeleted(this),
            ]),
            asphalt_performer: new FormControl(
                planning.asphalt_performer ?? this.mainPlanning?.entity?.default_asphalt_performer_id,
                [RequiredRule(this), userIsNotDeleted(this)]
            ),
            contractor: new FormControl(planning.contractor, [Validators.maxLength(40), RequiredRule(this)]),
            worknumber: new FormControl(planning.worknumber, [Validators.maxLength(40), RequiredRule(this)]),
            location: new FormControl(planning.location, [Validators.maxLength(200), RequiredRule(this)]),
            asphalt_location: new FormControl(planning.asphalt_location, [
                Validators.maxLength(200),
                RequiredRule(this),
            ]),
            traffic_controllers: new FormControl(planning.traffic_controllers, [
                Validators.max(250),
                RequiredRule(this),
            ]),
            traffic: new FormControl(planning.traffic, RequiredRule(this)),
            mobile_crane: new FormControl(planning.mobile_crane),
            pouring_off: new FormControl(planning.pouring_off, RequiredRule(this)),
            hotbox: new FormControl(planning.hotbox),
            scatter: new FormControl(planning.scatter, RequiredRule(this)),
            sticky_wagon: new FormControl(planning.sticky_wagon),
            hire_people: new FormControl(),
            description: new FormControl(planning.description),
            afas_project_id: new FormControl(planning.afas_project_id),
            reset_transport: new FormControl(resetTransport),
            resident_letter: new FormControl(planning.resident_letter, RequiredRule(this)),
        });

        if (!this.viewModel.projectmanagerNotOwn) {
            this.form.get('projectmanager').disable();
        }

        this.subscriptions.add(this.form.valueChanges.pipe(debounceTime(25)).subscribe(() => this.formChanges()));
        this.subscriptions.add(
            this.form
                .get('date')
                .get('date')
                .valueChanges.subscribe(value => {
                    if (value) {
                        if (!this.mainPlanning.begindate) {
                            this.mainPlanning.begindate = new Date(value);
                            this.mainPlanning.begindate.setHours(6);
                            this.mainPlanning.enddate = new Date(this.mainPlanning.begindate);
                            this.mainPlanning.enddate.setHours(Settings.MAX_TIMESPAN_HOURS);
                        }
                        const oldDate = new Date(this.mainPlanning.begindate);
                        const newDate = new Date(value);
                        Utils.setTime(oldDate, 0, 0);
                        Utils.setTime(newDate, 0, 0);
                        const diffDays = Math.round((newDate.getTime() - oldDate.getTime()) / 36e5 / 24);
                        const newBeginDate = new Date(this.mainPlanning.begindate);
                        newBeginDate.setDate(newBeginDate.getDate() + diffDays);
                        const newEndDate = new Date(this.mainPlanning.enddate);
                        newEndDate.setDate(newEndDate.getDate() + diffDays);
                        this.mainPlanning.begindate = newBeginDate;
                        this.mainPlanning.enddate = newEndDate;

                        if (this.asphaltListComponent) {
                            this.asphaltListComponent.reValidateFields(diffDays);
                        }
                        if (this.employeesComponent) {
                            this.employeesComponent.reValidateFields(diffDays);
                        }
                        if (this.wipetruckListComponent) {
                            this.wipetruckListComponent.reValidateFields(diffDays);
                        }
                        if (this.cutterListComponent) {
                            this.cutterListComponent.reValidateFields(diffDays);
                        }
                        this.form.get('date').get('endtime').setValue(newEndDate.getTime());
                        this.form.get('date').get('begintime').setValue(newBeginDate.getTime());
                        this.setTimesSubscription();
                    } else {
                        if (this.avCheckSubscriptions) {
                            this.avCheckSubscriptions.unsubscribe();
                        }
                        this.mainPlanning.begindate = this.mainPlanning.enddate = null;
                    }
                    this.updateFixedState();
                })
        );
        this.subscriptions.add(
            this.form
                .get('date')
                .get('begintime')
                .valueChanges.pipe(debounceTime(25))
                .subscribe(value => {
                    if (this.mainPlanning.begindate) {
                        const origBegin = new Date(this.mainPlanning.begindate);
                        const origEnd = new Date(this.mainPlanning.enddate);
                        this.mainPlanning.begindate.setTime(value);
                        if (!disabledWhenFinal(this)) {
                            if (this.asphaltListComponent) {
                                this.asphaltListComponent.mainTimeChanged(origBegin, origEnd);
                            }
                            if (this.wipetruckListComponent) {
                                this.wipetruckListComponent.mainItemBeginTimeChanged(origBegin, origEnd, value);
                            }
                            if (this.cutterListComponent) {
                                this.cutterListComponent.mainItemBeginTimeChanged(origBegin, origEnd, value);
                            }
                        }
                        this.genEndTimesList();
                        Utils.triggerValidation(this.form, [
                            this.form.get('date').get('date'),
                            this.form.get('date').get('begintime'),
                            this.statusControl,
                        ]);
                    }
                })
        );
        this.subscriptions.add(
            this.form
                .get('date')
                .get('endtime')
                .valueChanges.pipe(debounceTime(25))
                .subscribe(value => {
                    if (this.mainPlanning.begindate) {
                        const origBegin = new Date(this.mainPlanning.begindate);
                        const origEnd = new Date(this.mainPlanning.enddate);
                        this.mainPlanning.enddate.setTime(value);
                        if (this.asphaltListComponent) {
                            this.asphaltListComponent.mainTimeChanged(origBegin, origEnd);
                        }
                        if (this.wipetruckListComponent) {
                            this.wipetruckListComponent.mainItemEndTimeChanged(origBegin, origEnd, value);
                        }
                        if (this.cutterListComponent) {
                            this.cutterListComponent.mainItemEndTimeChanged(origBegin, origEnd, value);
                        }
                        Utils.triggerValidation(this.form, [
                            this.form.get('date').get('date'),
                            this.form.get('date').get('endtime'),
                            this.form.get('date').get('begintime'),
                            this.statusControl,
                        ]);
                    }
                })
        );

        this.subscriptions.add(
            this.form.get('contractor').valueChanges.subscribe(value => {
                value = value ? value : '';
                const sub = this.autocompleteService.getByType(AutocompleteType.contractors).subscribe(autoItems => {
                    this.autocompleteContractors = autoItems.filter(a =>
                        a.toLowerCase().includes(('' + value).toLowerCase())
                    );
                });
                sub.unsubscribe();
            })
        );

        this.autocompletePouringOff = Settings.pouring_off_defaults;

        if (this.viewModel.set) {
            this.form.addControl(
                'sets',
                new FormControl(
                    {
                        value: planning.planning_sets ? planning.planning_sets.map(e => e.entity_id) : [],
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                        validators: RequiredRule(this),
                    }
                )
            );
        }
        if (this.viewModel.dumpers) {
            this.form.addControl(
                'dumpers',
                new FormControl(
                    {
                        value: planning.planning_dumpers ? planning.planning_dumpers.map(e => e.entity_id) : [],
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                    }
                )
            );
        }
        if (this.viewModel.rollers) {
            this.form.addControl(
                'rollers',
                new FormControl(
                    {
                        value: planning.planning_rollers ? planning.planning_rollers.map(e => e.entity_id) : [],
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                    }
                )
            );
        }
        if (this.viewModel.asphaltOthers) {
            this.form.addControl(
                'asphalt_others',
                new FormControl(
                    {
                        value: planning.planning_asphalt_others
                            ? planning.planning_asphalt_others.map(e => e.entity_id)
                            : [],
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                    }
                )
            );
        }
        if (this.viewModel.asfaltteam) {
            this.form.addControl(
                'asfaltteam',
                new FormControl(
                    {
                        value: mainPlanning.entity_id,
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        validators: RequiredRule(this),
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                    }
                )
            );
        }
        if (this.viewModel.projectteam) {
            this.form.addControl(
                'projectteam',
                new FormControl(
                    {
                        value: mainPlanning.entity_id,
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        validators: RequiredRule(this),
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                    }
                )
            );
        }

        if (this.viewModel.preparationteam) {
            this.form.addControl(
                'preparationteam',
                new FormControl(
                    {
                        value: mainPlanning.entity_id,
                        disabled: disabledWhenFinal(this),
                    },
                    {
                        validators: RequiredRule(this),
                        asyncValidators: entityAvailableValidator(
                            this.planningHasService,
                            this.entitiesMap,
                            mainPlanning
                        ),
                    }
                )
            );
        }

        if (this.viewModel.wipetruck) {
            const wipetruckPlanning = mainPlanning as PlanningHasEntity;
            const fgDriverUserId = new FormControl(wipetruckPlanning.driver_user_id, {
                asyncValidators: localUserAvailableValidator(
                    wipetruckPlanning as PlanningHasEntity,
                    this.userPlanningService,
                    this.planningHasService,
                    !AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement)
                ),
            });
            this.form.addControl(
                'wipetruck',
                new FormGroup({
                    wipetruck: new FormControl(
                        wipetruckPlanning.entity_id,
                        RequiredRule(this),
                        entityAvailableValidator(this.planningHasService, this.entitiesMap, mainPlanning)
                    ),
                    driver_user_id: fgDriverUserId,
                    type: new FormControl(wipetruckPlanning.type, Validators.required),
                })
            );
        }
        if (this.viewModel.cutter) {
            const cutterPlanning = mainPlanning as PlanningCutter;
            const fgDriverUserId = new FormControl(cutterPlanning.driver_user_id, {
                asyncValidators: localUserAvailableValidator(
                    cutterPlanning as PlanningHasEntity,
                    this.userPlanningService,
                    this.planningHasService,
                    !AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement)
                ),
            });
            this.form.addControl(
                'cutter',
                new FormGroup({
                    cutter: new FormControl(
                        cutterPlanning.entity_id,
                        Validators.required,
                        entityAvailableValidator(this.planningHasService, this.entitiesMap, mainPlanning)
                    ),
                    driver_user_id: fgDriverUserId,
                    location: new FormControl(cutterPlanning.location, RequiredRule(this)),
                    tons: new FormControl(cutterPlanning.tons, RequiredRule(this)),
                    trucks: new FormControl(cutterPlanning.trucks, RequiredRule(this)),
                    thickness: new FormControl(cutterPlanning.thickness, RequiredRule(this)),
                    hiring_id: new FormControl(cutterPlanning.hiring_id, RequiredRule(this)),
                    name: new FormControl(cutterPlanning.name),
                })
            );
        }

        if (this.viewModel.formDisabled) {
            setTimeout(() => {
                this.form.get('date').disable({ emitEvent: false });
                this.form.disable({ emitEvent: false });
            });
        }
        if (this.viewModel.statusDisabled) {
            this.form.get('status_key').disable();
        }

        this.statusControl.valueChanges.pipe(debounceTime(25)).subscribe(() => {
            this.updateStatus();
        });
        this.form
            .get('afas_project_id')
            .valueChanges.pipe(debounceTime(25))
            .subscribe(() => {
                this.updateLeave();
            });
    }

    private createLeave() {
        const leave = new Leave();
        leave.hourtype = RealisationHourtype.sleep;
        leave.afas_project_id = this.planning.afas_project_id;
        leave.begindate = new Date(this.mainPlanning.begindate);
        leave.enddate = new Date(this.mainPlanning.begindate);
        leave.enddate.setHours(leave.enddate.getHours() + Settings.DEFAULT_DURATION_SLEEP);
        leave.comment = 'Slaapdag';
        leave.begintime = formatDate(leave.begindate, 'HH:mm', 'nl');
        leave.endtime = formatDate(leave.enddate, 'HH:mm', 'nl');
        leave.users = [];
        return leave;
    }

    updateLeave(reInit = false) {
        if ((!this.planning?.id || reInit) && this.statusControl.value === this.PlanningStatus.PlanningSlaapdag) {
            const from = Utils.setTime(new Date(this.mainPlanning.begindate), 0, 0);
            from.setDate(from.getDate() - 2);
            const to = new Date(this.mainPlanning.begindate);
            this.subscriptions.add(
                this.planningService.getFilteredList(from, to).subscribe(plannings => {
                    const pastPlannings = plannings.filter(p => p.afas_project_id === this.planning.afas_project_id);
                    const userPlanning = pastPlannings
                        .map(p => p.user_planning)
                        .flat()
                        .filter((up, i, ups) => ups.findIndex(usr => usr.user_id === up.user_id) === i);
                    const leave = !this.leave ? this.createLeave() : this.leave;
                    leave.users = userPlanning.map(up => up.user);
                    this.leave = leave;
                })
            );
        }
    }

    private updateStatus() {
        this.planning.status_key = this.statusControl.value;
        this.updateLeave(this.planning.id && this.planning.status_key != this.origPlanning.status_key);
        const dateControls = [
            this.form.get('date').get('date'),
            this.form.get('date').get('begintime'),
            this.form.get('date').get('endtime'),
        ];
        this.enforceDefinitiefWhenFixed();

        // When PlanningStatus.bakvanwessel, date should be empty
        if (this.statusControl.value === this.PlanningStatus.PlanningBakVanWessel) {
            dateControls.forEach(control => {
                control.reset(null);
                control.disable();
            });
        } else if (this.initialStatus === this.PlanningStatus.PlanningBakVanWessel) {
            // When previous state was PlanningStatus.bakvanwessel, refill date with today
            if (dateControls[0].disabled) {
                dateControls.forEach(control => {
                    control.enable();
                });
            }
        }

        if (this.statusControl.value === this.PlanningStatus.PlanningSlaapdag && !this.planning.id) {
            const startDate = new Date(this.form.get('date').get('begintime').value);
            const endTime = Utils.setTime(
                startDate,
                startDate.getHours() + Settings.DEFAULT_DURATION_SLEEP,
                startDate.getMinutes()
            );
            this.mainPlanning.enddate = new Date(endTime);
            this.form.get('date').get('endtime').setValue(endTime.getTime());
        }
        if (this.statusControl.value === this.PlanningStatus.PlanningGeblokkeerd && !this.planning.id) {
            const startDate = Utils.setTime(new Date(this.form.get('date').get('begintime').value), 0, 0);
            const endDate = Utils.setTime(new Date(startDate), 24, 0);
            this.mainPlanning.begindate = new Date(startDate);
            this.form.get('date').get('begintime').setValue(this.mainPlanning.begindate.getTime());
            this.mainPlanning.enddate = new Date(endDate);
            this.form.get('date').get('endtime').setValue(this.mainPlanning.enddate.getTime());
        }

        Utils.triggerValidation(this.form, [this.statusControl]);
        if (this.wipetruckListComponent) {
            this.wipetruckListComponent.updateStatus(this.statusControl.value);
        }
        if (this.cutterListComponent) {
            this.cutterListComponent.updateStatus(this.statusControl.value);
        }
        if (this.asphaltListComponent) {
            this.asphaltListComponent.updateStatus(this.statusControl.value);
        }
        this.viewModel.updateViewState(
            this.mainPlanning.entitytype_key,
            LocalStorage.getUser(),
            this.planning,
            !!this.fixedDate
        );
    }

    backToConcept() {
        // TODO check dirty users
        if (
            this.form.dirty ||
            (this.asphaltListComponent && this.asphaltListComponent.checkDirty()) ||
            (this.cutterListComponent && this.cutterListComponent.checkDirty()) ||
            (this.wipetruckListComponent && this.wipetruckListComponent.checkDirty())
        ) {
            this.confirmDialogService
                .confirm({
                    title: 'Sla eerst je wijzigingen op',
                    text: 'Voordat je een planning kunt terugzetten naar concept moet je eerst de wijzigingen die je hebt gemaakt opslaan.',
                    confirm: 'Oke',
                    cancel: null,
                })
                .then(() => {});
        } else {
            let trucks = this.planning.planning_has.filter(
                pha =>
                    ([EntityTypeCode.Truck, EntityTypeCode.CutterTruck, EntityTypeCode.AsfaltTruck] as any).indexOf(
                        pha.entitytype_key
                    ) !== -1
            )?.length;
            trucks += this.planning.planning_has.filter(pha => !!pha.truck_entity_id)?.length;

            const cranes = this.planning.planning_has.filter(
                pha => [EntityTypeCode.Crane].indexOf(pha.entitytype_key as any) !== -1
            )?.length;
            const kleefw = this.planning.planning_has.filter(
                pha => [EntityTypeCode.StickyWagon].indexOf(pha.entitytype_key as any) !== -1
            )?.length;
            let lowloader = this.planning.planning_has.filter(
                pha => [EntityTypeCode.LowLoader].indexOf(pha.entitytype_key as any) !== -1
            )?.length;
            lowloader += this.planning.planning_has.filter(
                pha => !!pha.lowloader_entity_id && this.entitiesMap.get(pha.lowloader_entity_id)?.use_once
            )?.length;

            const dumpersUnequal = this.planning.planning_has.filter(
                pha =>
                    [EntityTypeCode.Dumper].indexOf(pha.entitytype_key as any) !== -1 &&
                    (Utils.getTimeOrNull(pha.begindate) !== Utils.getTimeOrNull(this.mainPlanning.begindate) ||
                        Utils.getTimeOrNull(pha.enddate) !== Utils.getTimeOrNull(this.mainPlanning.enddate))
            )?.length;
            const setsUnequal = this.planning.planning_has.filter(
                pha =>
                    [EntityTypeCode.Set].indexOf(pha.entitytype_key as any) !== -1 &&
                    (Utils.getTimeOrNull(pha.begindate) !== Utils.getTimeOrNull(this.mainPlanning.begindate) ||
                        Utils.getTimeOrNull(pha.enddate) !== Utils.getTimeOrNull(this.mainPlanning.enddate))
            )?.length;

            let text = `Terugzetten naar concept heeft de volgende consequenties:<br><br>`;

            if (trucks || cranes || kleefw || lowloader) {
                text += `<b>Vervalt</b><br>
                ${trucks ? `${trucks} vrachtwagens, ` : ''}
                ${cranes ? `${cranes} kranen, ` : ''}
                ${kleefw ? `${kleefw} kleefwagens, ` : ''}
                ${lowloader ? `${lowloader} diepladers, ` : ''}<br><br>`;
            }
            if (dumpersUnequal || setsUnequal) {
                text += `<b>Tijden terug naar hoofditem</b><br>
                ${dumpersUnequal ? `${dumpersUnequal} dumpers, ` : ''}
                ${setsUnequal ? `${setsUnequal} sets` : ''}<br><br>`;
            }

            text += `Dit kan niet ongedaan gemaakt worden. Weet je zeker dat je door wilt gaan?<br>`;

            if (trucks + cranes + kleefw + lowloader + dumpersUnequal + setsUnequal === 0) {
                text = 'Er zijn geen consequenties voor ingepland materiaal.';
            }

            this.confirmDialogService
                .confirm({
                    title: 'Defintieve planning terug naar concept',
                    text,
                    confirm: 'Terugzetten naar concept',
                    cancel: 'Annuleren',
                })
                .then(
                    () => {
                        this.initialStatus = this.PlanningStatus.PlanningReservering;
                        this.form = null;
                        setTimeout(() => {
                            this.planning = structuredClone(this.origPlanning);
                            this.createMainForm(this.planning, this.mainPlanning, true);
                            const allPromises = [
                                this.cutterListComponent?.validateForms() ?? of(true),
                                this.wipetruckListComponent?.validateForms() ?? of(true),
                                this.asphaltListComponent?.validateForms() ?? of(true),
                                Utils.triggerValidationP(this.form),
                            ];

                            Promise.all(allPromises).then(
                                () => {},
                                () => {}
                            );
                        });
                    },
                    () => {}
                );
        }
    }

    changeFinalStatus(status: string) {
        this.statusControl.setValue(status);
        this.planning.status_key = status;
        this.save();
    }

    private updateFixedState() {
        if (!this.latestFixedUntilItem) {
            return;
        }
        const isFixedByUntil =
            this.mainPlanning.begindate !== null &&
            new Date(this.latestFixedUntilItem.fixeduntil).getTime() >= new Date(this.mainPlanning.begindate).getTime();
        const isFixedByDay =
            this.mainPlanning.begindate !== null &&
            this.isSpecificFixedDay(new Date(this.mainPlanning.begindate), this.fixedDaysList);
        const isFixed = isFixedByUntil || isFixedByDay;

        this.viewModel.updateViewState(
            this.mainPlanning.entitytype_key,
            LocalStorage.getUser(),
            this.planning,
            isFixed
        );
        this.fixedDate = isFixed
            ? isFixedByDay
                ? new Date(this.mainPlanning.begindate)
                : new Date(this.latestFixedUntilItem.fixeduntil)
            : null;
        this.mayBackToConcept =
            (!isFixed && this.initialStatus !== this.PlanningStatus.PlanningBevestigd) ||
            AuthorisationService.hasFunctionality(Functionalities.TransportplanningManagement);

        if (this.form) {
            this.enforceDefinitiefWhenFixed();
        }
    }

    private enforceDefinitiefWhenFixed() {
        if (
            this.fixedDate &&
            !AuthorisationService.hasFunctionality(Functionalities.PlanningOverviewManagement) &&
            ![
                this.PlanningStatus.PlanningDefinitief,
                this.PlanningStatus.PlanningBevestigd,
                this.PlanningStatus.PlanningSlaapdag,
                this.PlanningStatus.PlanningGeblokkeerd,
            ].includes(this.planning.status_key)
        ) {
            this.planning.status_key = this.PlanningStatus.PlanningDefinitief;
            this.form.get('status_key').setValue(this.PlanningStatus.PlanningDefinitief);
        }
    }

    private isSpecificFixedDay(date: Date, fixedDays: PlanningFixed[]): boolean {
        const dayKey = this.dayKey(date);
        return fixedDays.some(fixedDay => this.dayKeyFromInput(fixedDay.fixed_date) === dayKey);
    }

    private dayKey(date: Date): string {
        return Utils.formatDate(date);
    }

    private dayKeyFromInput(value: Date | string): string {
        if (typeof value === 'string') {
            return value.substring(0, 10);
        }
        return this.dayKey(value);
    }
}
